var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lab",class:_vm.meta.colorClass},[(_vm.meta.src)?_c('img',{staticClass:"lab__img",attrs:{"src":_vm.meta.src,"alt":""}}):_c('feather-icon',{attrs:{"icon":_vm.meta.icon,"size":"16"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }